import { TicketsPageSize } from '../../models/ticketsPage';
import { CheckoutState } from '../../state';

export const getIsTicketSelectionCompactSizeFlow = ({ app }: CheckoutState) =>
    app.request?.params?.ticketsPageSize === TicketsPageSize.compact;
